<template>
  <div class="filemgr-folder" :style="propStyle">
    <div class="filemgr-folder-header">
      <button
        @click="create.modal = true"
        class="btn btn-xs btn-outline-secondary"
      >
        Шинэ хавтас
      </button>
      <!-- <button
        :disabled="folderCur.id == null || folderMode != undefined"
        class="btn btn-xs btn-outline-secondary mg-l-auto"
      >
        Хавтсыг хуваалцах
      </button> -->
    </div>
    <div class="filemgr-folder-body" style="max-height: calc(100vh - 115px)">
      <label
        class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-x-10 mg-t-10"
        >Миний хавтсууд</label
      >
      <nav class="nav nav-sidebar tx-13">
        <a
          @click="handleNodeClick({ id: null })"
          class="nav-link"
          :class="{ active: folderCur.id == null }"
          ><feather type="folder"></feather> <span>Бүх хавтас</span></a
        >
      </nav>
      <vue-custom-scrollbar style="height: calc(100vh - 505px);">
        <Tree
          :key="treeKey"
          node-key="id"
          node-key1="label"
          :data="folders"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
          :expand-on-click-node="false"
          class="dynamic-folder-tree"
        >
          <div slot-scope="{ node }" class="d-flex align-items-center">
            <feather
              :type="`${node.key == folderCur.id ? 'chevron-right' : 'folder'}`"
              :size="18"
              class="mg-r-10"
            ></feather>
            <span>
              {{ node.label }}
            </span>
          </div>
        </Tree>
      </vue-custom-scrollbar>
      <vue-custom-scrollbar style="height: 400px;">
        <label
          class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-x-10 mg-t-20"
          >Надад хуваалцсан</label
        >
        <nav class="nav nav-sidebar tx-13">
          <a
            @click="handleNodeClick(f, 2)"
            class="nav-link"
            v-for="(f, i) in sharedFolders"
            :key="i"
            :class="{ active: folderCur.id == f.id }"
          >
            <feather type="folder"></feather>
            <span>{{ f.folderName }}</span>
          </a>
        </nav>
      </vue-custom-scrollbar>
    </div>

    <b-modal
      v-model="create.modal"
      title="Хавтас үүсгэх"
      centered
      @ok="createFolder"
    >
      <div class="input-group my-4">
        <div class="input-group-prepend">
          <span class="input-group-text">Хавтасны нэрээ оруулна уу</span>
        </div>
        <input type="text" v-model="create.folderName" class="form-control" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { Tree } from "element-ui";
import { request } from "@/api/all";
var LTT = require("list-to-tree");

export default {
  components: {
    Tree,
    vueCustomScrollbar
  },
  props:{
    propStyle:{
      type: String,
      default: () => '',
    }
  },
  data() {
    return {
      folders: [],
      defaultProps: {
        children: "children",
        label: "title",
        iid: "id"
      },
      foldersFlat: [],
      folderCur: {
        id: null
      },
      treeKey: 0,
      folderMode: undefined,
      create: {
        modal: false,
        folderName: ""
      },
      sharedFolders: []
    };
  },
  mounted() {
    this.init();
    this.initSharedFolders();
  },
  methods: {
    showModal(){
      this.create.modal=true;

    },
    init() {
      request({
        api: { method: "GET", url: "Media/getFolderTreeData" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.foldersFlat = res.data.folders;
          var ltt = new LTT(res.data.folders, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.folders = ltt.GetTree();
          //console.log(this.folders);
        }
      });
    },
    handleNodeClick(data, mode) {
      //console.log('mode', mode);
      if (mode != undefined && mode == 2) {
        this.treeKey++;
        this.folderMode = mode;
      } else if (data.id == null) {
        this.treeKey++;
      } else {
        this.folderMode = undefined;
      }

      this.folderCur = data;
      this.$emit("on-folder-selected", data);
    },
    createFolder() {
      request({
        api: { method: "POST", url: "Media/CreateFolder" },
        data: {
          folderName: this.create.folderName,
          parentId: this.folderCur.id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.create.modal = false;
          this.create.folderName = false;
          this.folderCur.id = null;
          this.init();
        }
      });
    },
    initSharedFolders() {
      request({
        api: { method: "GET", url: "Media/GetSharedFolders" },
        params: {
          parentId: -1
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.sharedFolders = res.data.folders;
          //console.log(res);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.dynamic-folder-tree {
  .el-tree-node {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    .el-tree-node__content {
      height: 30px;
    }
  }
  .is-current {
    color: #0168fa;
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
